export { ProductListPage } from './view/product-list-page';

export { productSagas } from './sagas';
export {
  default as productSlice,
  getProducts,
  generateLink,
  generateLinkFailed,
  generateLinkSuccess,
} from './slice';
export { selectProductsState, selectGenrateLinkState } from './selectors';

export type { IProduct } from './types';
